module.exports = __webpack_public_path__ + "img/42.bb5bdbb8.png";